"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    progress: {
        show: true,
        width: 18,
        roundCap: true,
        itemStyle: {
            color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                    {
                        offset: 0,
                        color: "#FFA4B2 "
                    },
                    {
                        offset: 0.5,
                        color: "#81ADF9"
                    },
                    {
                        offset: 1,
                        color: "#69EEBE "
                    }
                ],
                global: false
            }
        }
    },
    startAngle: 225,
    endAngle: -45,
    splitNumber: 5,
    pointer: {
        width: 8,
        itemStyle: {
            color: "#6BC0E7"
        }
    },
    axisLine: {
        roundCap: true,
        lineStyle: {
            width: 18
        }
    },
    axisTick: {
        show: false
    },
    splitLine: {
        distance: 0,
        length: 10,
        lineStyle: {
            width: 2,
            color: "#6BC0E7"
        }
    },
    axisLabel: {
        distance: 25,
        color: "#999",
        fontSize: 14
    },
    anchor: {
        show: true,
        showAbove: true,
        size: 25,
        itemStyle: {
            borderWidth: 10,
            borderColor: "#6BC0E7"
        }
    },
    title: {
        show: false
    },
    detail: {
        valueAnimation: true,
        fontSize: 30,
        color: "#6BC0E7",
        offsetCenter: [0, "70%"]
    }
};
//# sourceMappingURL=Gauge.js.map